var React = require('react');

function IconTrash (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#ccc","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"},[React.createElement("path",{"d":"M.849 1.843L7.812.848","key":0}),React.createElement("path",{"d":"M3.535 5.978v6.364","key":1}),React.createElement("path",{"d":"M6.582 5.978v6.364","key":2}),React.createElement("path",{"d":"M7.258 14.463h-4.4a1.592 1.592 0 01-1.589-1.511L.814 3.857h8.485l-.455 9.095a1.592 1.592 0 01-1.586 1.511z","key":3})]));
}

IconTrash.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16"};

module.exports = IconTrash;

IconTrash.default = IconTrash;
